<template>
  <span>
    Used Advanced Airway
  </span>
</template>
<script>

export default {
  name: 'AdvancedAirwayUsed',

  props: {
    field: {
      type: Object,
      required: true,
    },
    condition: {
      type: Object,
      required: true,
    },
  },
};
</script>
